<template>
  <div class="wizard-body small-12 medium-9 columns height-auto">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.AUTH.TITLE')"
    />
    <div class="channel-list">
      <channel-item
        v-for="channel in displayedChannels"
        :key="channel.key"
        :channel="channel"
        :enabled-features="enabledFeatures"
        @channel-item-click="initChannelAuth"
      />
    </div>
    <div class="load-more-wrap" v-if="!showAllChannels && channelList.length > 4">
      <a href="#" class="load-more-link" @click.prevent="showAllChannels = true">
        {{ $t('INBOX_MGMT.ADD.CHANNEL_LIST.LOAD_MORE') }}
      </a>
    </div>
  </div>
</template>

<script>
import ChannelItem from 'dashboard/components/widgets/ChannelItem';
import router from '../../../index';
import PageHeader from '../SettingsSubPageHeader';
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  components: {
    ChannelItem,
    PageHeader,
  },
  mixins: [globalConfigMixin],
  data() {
    return {
      enabledFeatures: {},
      showAllChannels: false,
    };
  },
  computed: {
    account() {
      return this.$store.getters['accounts/getAccount'](this.accountId);
    },
    displayedChannels() {
      if (this.showAllChannels) {
        return this.channelList;
      }
      return this.channelList.slice(0, 4);
    },
    isSuperAdmin() {
      return this.currentUser?.type === 'SuperAdmin';
    },
    channelList() {
      const { apiChannelName, apiChannelThumbnail } = this.globalConfig;
      return [
        { key: 'whatsapp', name: 'WhatsApp' },
        { key: 'website', name: 'Chat Web' },
        ...(this.isSuperAdmin
          ? [
              { key: 'facebook', name: 'Messenger' },
              { key: 'instagram', name: 'Instagram' },
            ]
          : []),
        // { key: 'twitter', name: 'Twitter' },
        // { key: 'sms', name: 'SMS' },
        { key: 'email', name: 'Email' },
        {
          key: 'api',
          name: apiChannelName || 'API',
          thumbnail: apiChannelThumbnail,
        },
        { key: 'telegram', name: 'Telegram' },
        // { key: 'line', name: 'Line' },
        { key: 'voll360', name: 'Voll 360' },
        { key: 'wetalkie', name: 'Wetalkie' },
        { key: 'omne', name: '2CX' },
        { key: 'zendesk', name: 'Zendesk' },
        { key: 'infobip', name: 'Infobip' },
        { key: 'multimedia', name: this.$t('INBOX_MGMT.ADD.CHANNEL_LIST.MULTIMEDIA.NAME') },
      ];
    },
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
      currentUser: 'getCurrentUser',
    }),
  },
  mounted() {
    this.initializeEnabledFeatures();
  },
  activated() {
    this.showAllChannels = false;
  },
  methods: {
    async initializeEnabledFeatures() {
      await this.$store.dispatch('accounts/get', this.accountId);
      this.enabledFeatures = this.account.features;
    },
    initChannelAuth(channel) {
      const params = {
        page: 'new',
        sub_page: channel,
      };
      router.push({ name: 'settings_inboxes_page_channel', params });
    },
  },
};
</script>
<style scoped lang="scss">
.height-auto {
  height: auto;
}

.channel-list {
  margin-top: var(--space-medium);
  margin-bottom: var(--space-medium);
}

.load-more-wrap {
  text-align: center;
  margin-top: var(--space-normal);
  margin-bottom: var(--space-large);

  .load-more-link {
    color: var(--w-500);
    font-weight: var(--font-weight-medium);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
